export const styles = {
  nav: [
    "h-full",
    "flex",
    "flex-col",
    "justify-center",
    "items-center",
    "text-white",
    "select-none",
  ].join(" "),
  container: [
    "bg-black",
    "absolute",
    "inset-0",
    "z-10",
    "transform",
    "-translate-x-full",
  ].join(" "),
  "icon-size": ["w-8", "h-8"].join(" "),
};
